module.exports = __webpack_public_path__ + "static/media/learning-bg.b29c2d53.png";